import moment from 'moment';
const CertificationConfic: any = [
  {
    key: 'displayName',
    label: 'Display Name',
    defaultValue: '',
    type: 'text',
    size: 6,
    rules: {
      required: {
        value: true,
        message: 'Name should not be null'
      }
    }
  },
  {
    key: 'type',
    label: 'Field Type',
    defaultValue: '',
    values: [
      { label: 'String', value: 'String' },
      { label: 'Enum', value: 'Enum' },
      { label: 'Integer', value: 'Integer' },
      { label: 'Date', value: 'Date' }
    ],
    type: 'dropdown',
    size: 6,
    required: true,
    labelStyleType: 'InputLabel',
    rules: {
      required: {
        value: true,
        message: 'Type should not be null'
      }
    }
  },
  {
    key: 'defaultValue',
    label: 'Default Value',
    defaultValue: '',
    type: 'text',
    size: 6,
    required: false
  },
  {
    key: 'path',
    label: 'Path',
    defaultValue: '',
    type: 'text',
    size: 6,
    required: false,
    disabled: true
  },
  {
    key: 'required',
    label: 'Required',
    defaultValue: '',
    values: [
      { label: 'True', value: 'true' },
      { label: 'False', value: 'false' }
    ],
    type: 'dropdown',
    size: 6,
    required: false,
    labelStyleType: 'InputLabel'
  },
  {
    key: 'hide',
    label: 'Hidden Field',
    defaultValue: 'false',
    values: [
      { label: 'True', value: true },
      { label: 'False', value: false }
    ],
    type: 'dropdown',
    size: 6,
    required: false,
    labelStyleType: 'InputLabel'
  },
  {
    key: 'group',
    label: 'Group',
    defaultValue: '',
    type: 'text',
    size: 6,
    required: false
  },
  {
    key: 'mapFromPath',
    label: 'Map from Path',
    defaultValue: '',
    type: 'hidden',
    size: 6,
    required: false
  },
  {
    key: 'values',
    label: 'Value(s)',
    defaultValue: '',
    type: 'hidden',
    size: 6,
    required: false,
    tooltip: 'Please add coma ( , ) separated values for ENUM'
  }
];

const testDatacolumns = [
  {
    title: 'Test Data Name',
    field: 'testDataName',
    headerStyle: { zIndex: 11 }
  },
  {
    title: 'Service Name',
    field: 'serviceNm',
    headerStyle: { zIndex: 11 }
  },
  {
    title: 'Operation',
    field: 'operation',
    headerStyle: { zIndex: 11 }
  }
];

const testRulescolumns = [
  {
    title: 'Service Name',
    field: 'serviceNm',
    headerStyle: { zIndex: 11 },
    render: (rowData: any) => rowData.serviceNm
  },
  {
    title: 'Operation Name',
    field: 'operation',
    headerStyle: { zIndex: 11 },
    render: (rowData: any) => rowData.operation
  },
  {
    title: 'Updated On',
    field: 'updatedOn',
    headerStyle: { zIndex: 11 },
    render: (rowData: any) => moment(rowData.updatedOn).format('MM/DD/YYYY hh:mm:ss A')
  }
];

const ParameterTypeConfig = [
  {
    label: 'Authentication Header',
    value: 'authHeaders'
  },
  {
    label: 'Form Parameter',
    value: 'formParams'
  },
  {
    label: 'Request Header',
    value: 'requestHeaders'
  },
  {
    label: 'Request Body',
    value: 'authBodyParameters'
  }
];

const PrimaryParamterConfig = [
  {
    label: 'Identifier',
    value: 'identifier'
  },
  {
    label: 'Secret',
    value: 'secret'
  },
  {
    label: 'Auth Url',
    value: 'authUrl'
  }
];
const testScenariocolumns = [
  {
    title: 'Test Scenario Name',
    field: 'testScenarioName',
    headerStyle: { zIndex: 11 }
  },
  {
    title: 'Service Name',
    field: 'serviceNm',
    headerStyle: { zIndex: 11 }
  },
  // {
  //   title: 'Participant Type',
  //   field: 'participantType',
  //   headerStyle: { zIndex: 11 }
  // },
  {
    title: 'Description',
    field: 'description',
    headerStyle: { zIndex: 11 }
  },
  {
    title: 'Test Step Sequence',
    field: 'testStepSequence',
    headerStyle: { zIndex: 11 },
    hidden: true
  }
];

const participantTypes = [
  { label: 'Provider', value: 'PROVIDER' },
  { label: 'Customer', value: 'CUSTOMER' },
  { label: 'Aggregator', value: 'AGGREGATOR' }
];

const keysToShow = ['displayName', 'path', 'required', 'group'];

export {
  CertificationConfic,
  keysToShow,
  testDatacolumns,
  testScenariocolumns,
  participantTypes,
  testRulescolumns,
  ParameterTypeConfig,
  PrimaryParamterConfig
};
